import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setBreadcrumbs } from "@/store/slices/Breadcrumbs";
import AttendanceDashboard from "./components/AttendanceDashboard";
import WorkforceAnalyticsDashboard from "./components/WorkforceAnalyticsDashboard";

// ── Tab Names ──────────────────────────────────────────────
type TabName = "attendance" | "workforce";

// ── Tab Style Helpers ──────────────────────────────────────

const tabStyle = (active: boolean) => ({
  px: 3,
  py: 1,
  fontSize: "15px",
  fontWeight: (active ? 700 : 500) as number,
  color: active ? "#059AD9" : "#666666",
  cursor: "pointer",
  borderBottom: active ? "3px solid #059AD9" : "3px solid transparent",
  backgroundColor: active ? "rgba(5, 154, 217, 0.04)" : "transparent",
  transition: "all 0.2s ease",
  userSelect: "none" as const,
  "&:hover": {
    color: "#059AD9",
    backgroundColor: "rgba(5, 154, 217, 0.04)",
  },
});

// ── Main Container ─────────────────────────────────────────

const DashboardTabs: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<TabName>("attendance");
  useEffect(() => {
    dispatch<any>(
      setBreadcrumbs<any>([{
        path: "",
        label: t("common.Dashboard"),
      }])
    );
  }, [t, dispatch]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 70px)",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5F6FA",
      }}
    >
      {/* Tab Navigation Bar */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #E8E8E8",
          display: "flex",
          alignItems: "center",
          px: 3,
          flexShrink: 0,
        }}
      >
        <Box
          sx={tabStyle(activeTab === "attendance")}
          onClick={() => setActiveTab("attendance")}
        >
          {t("Dashboard.Attendance Dashboard")}
        </Box>
        <Box
          sx={tabStyle(activeTab === "workforce")}
          onClick={() => setActiveTab("workforce")}
        >
          {t("Dashboard.Workforce Analytics Dashboard")}
        </Box>

        <Box sx={{ flex: 1 }} />
      </Box>

      {/* Content Area */}
      <Box sx={{ p: activeTab === "workforce" ? 0 : "14px", flexGrow: 1, minHeight: 0, overflow: "auto" }}>
        {activeTab === "attendance" ? <AttendanceDashboard /> : <WorkforceAnalyticsDashboard />}
      </Box>
    </Box>
  );
};

export default DashboardTabs;
